import { PathElement } from './path-element.ts';
import { MatchingContext } from '../path-pattern.ts';
import { isPathSegment } from '../../../../http/server/path.ts';

export class LiteralPathElement extends PathElement {
    readonly #text: string;
    readonly #len: number;
    readonly #caseSensitive: boolean;

    constructor(pos: number, literalText: Uint16Array, caseSensitive: boolean, separator: number) {
        super(pos, separator);
        this.#len = literalText.length;
        this.#caseSensitive = caseSensitive;
        this.#text = String.fromCharCode(...(literalText));
    }

    matches(pathIndex: number, matchingContext: MatchingContext): boolean {
        if (pathIndex >= matchingContext.pathLength) {
            // no more path to match
            return false;
        }
        const pathSegment = matchingContext.pathElements[pathIndex];
        if (!isPathSegment(pathSegment)) {
            return false;
        }
        const value = pathSegment.valueToMatch;
        if (value.length !== this.#len) {
            // not enough data to match this path element
            return false;
        }

        if (this.#caseSensitive) {
            if (this.#text !== value) {
                return false;
            }
        }
        else {
            if (this.#text.toLowerCase() !== value.toLowerCase()) {
                return false;
            }
        }

        pathIndex++;
        if (this.noMorePattern()) {
            if (matchingContext.determinedRemainingPath) {
                matchingContext.remainingPathIndex = pathIndex;
                return true;
            }
            else {
                return (pathIndex === matchingContext.pathLength);
            }
        }
        else {
            return this.next!.matches(pathIndex, matchingContext);
        }
    }

    get normalizedLength(): number {
        return this.#len;
    }

    get chars(): Uint16Array {
        const arr = new Uint16Array(this.#len);
        for (let i = 0; i < this.#len; i++) {
            arr[i] = this.#text.charCodeAt(i);
        }
        return arr;
    }

    get literal() {
        return true;
    }

    toString(): string {
        return `Literal(${this.#text})`;
    }

}
